import {FC} from 'react'

interface Props {
    booking: Booking,
    setBooking: Function
}

const LoanCar: FC<Props> = ({booking, setBooking}) => {

    const handleClick = (value: any) => {
        booking.loan_car = value
        booking.loan_car_mercedes = false
        booking.loan_car_opel = false
        booking.submission.reload = true

        booking.calendar_carousel.index++
        booking.calendar_carousel.steps[2].active = true

        setBooking({
            ...booking,
        })
    }

    return (
        <>
            {booking.dateHasLoanCar && (
                <>
                    <h2 className="required">Lånebil</h2>
                    <div className={`submissions_option ${booking.loan_car === 'yes' ? "active" : ""}`}
                         onClick={() => handleClick('yes')}>
                        <h4>Ja tack</h4>
                        <p>Ingår: Självriskreducering, 10 mils bränsle per dygn och eventuell trängselskatt.<br/>Pris:
                            199 kr/dygn.</p>
                    </div>
                    <div className={`submissions_option ${booking.loan_car === 'no' ? "active" : ""}`}
                         onClick={() => handleClick('no')}>
                        <h4>Nej tack</h4>
                    </div>
                </>
            )}
        </>
    )
};

export default LoanCar
